const assetFunction = (url) => {
  return process.env.BASE_URL + 'assets/' + url
}
export default {
  asset(url) {
    return assetFunction(url)
  },
  imgUrl(img) {
    return assetFunction('img/' + img);
  },
  iconUrl(icon) {
    return assetFunction('img/icon/' + icon);
  },
  avatarUrl(avatar = null) {
    return avatar || assetFunction('img/no-avatar.png');
  },
  pictureUrl(url) {
    return url || assetFunction('img/no-image.png');
  }
};
